import React from 'react'

const SecondInstruction = () => (
  <p>
    <span>
      2. Pack the original item and the Packing Slip inside a box and ship it back to
      &nbsp;
      <span>
        CarParts.com 1301 Ave T, Grand Prairie, TX, 75050
      </span>
      &nbsp;
      using your preferred shipping carrier.
    </span>
  </p>
)

const ThirdInstruction = ({ itemTotal }) => (
  <p>
    <span>
      3. Once we have received the part,
      we&apos;ll review and process your claim that estimates to a refund of
      &nbsp;
      <span>
        $
        {itemTotal}
      </span>
      .
    </span>
  </p>
)

export const detailInstructionData = {
  header: 'How to get your Lifetime Replacement refund',
  list: [
    {
      Detail: function Detail() {
        return (
          <p>
            1. Click the “Submit Claim”
            button below, and print the Packing
            Slip on the next screen.
          </p>
        )
      },
    },
    {
      Detail: function Detail() {
        return (
          <p>
            <span>
              2. Pack the original item and the Packing Slip inside a box and ship it back to
              &nbsp;
              <span>
                CarParts.com 1301 Ave T, Grand Prairie, TX, 75050
              </span>
              &nbsp;
              using your preferred shipping carrier.
            </span>
          </p>
        )
      },
    },
    {
      Detail: ThirdInstruction,
    },
  ],
}

export const confirmationInstructionData = {
  header: 'Next Steps',
  list: [
    {
      Detail: function Detail() {
        return (
          <p>
            1. Print the Packing Slip by clicking the “Print Packing Slip” button below.
          </p>
        )
      },
    },
    {
      Detail: SecondInstruction,
    },
    {
      Detail: ThirdInstruction,
    },
  ],
}
